/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'

export type FromToDateProps = {
  fromDate?: string
  toDate: string
}

function FromToDate (props: FromToDateProps) {
  const intl = useIntl()
  const { fromDate, toDate } = props

  if (fromDate && toDate) {
    return intl.formatMessage({
      id: 'from_%_to_%',
      defaultMessage: 'Du {fromDate} au {toDate}'
    }, {
      fromDate: intl.formatDate(fromDate),
      toDate: intl.formatDate(toDate)
    })
  }
  return intl.formatMessage({
    id: 'from_%',
    defaultMessage: 'Du {fromDate}'
  }, {
    fromDate: intl.formatDate(fromDate)
  })
}

export default FromToDate
